/**
 * @description Simple directive to hide count when it overflows
 */
;(function () {
  angular
    .module('contrast.thermometer')
    .directive('thermometerCount', function () {
      return {
        restrict: 'A',
        link: function (scope, element) {
          scope.$watch(
            function () {
              return element.parent().width()
            },
            function (newValue) {
              if (angular.isNumber(newValue)) {
                if (newValue > element.width()) {
                  element.css('display', 'initial')
                } else {
                  element.css('display', 'none')
                }
              }
            }
          )
        }
      }
    })
})()
